import { Badge, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, GridLegacy as Grid, IconButton, Input, InputAdornment, InputBase, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import dayjs from '../../../../utils/dayjs-setup';
import React, { useContext, useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { AxiosInstance, DateFormatString, DialogType } from "../../../../utils/constants";
import {ActionTypes, AppContext} from "../../../../store/AppStore";
import styled from "@emotion/styled";
import { blue, grey, yellow } from "@mui/material/colors";
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RegistroSolicitud from "../../../../components/plataforma/programacion/registro-solicitud";
import { Adjust, Save } from "@mui/icons-material";
import {css} from "@emotion/css";

const DayContainerDefault = styled.div`
padding:5px;
border-radius:5px;
color:black;
background:${grey[500]};
text-align:center;

`;

const HelperBodega = styled.span`
font-size:12px;
display:block;
`;

const InputValue = styled.input`
border: 1px solid gray;
border-radius: 6px;
text-align: center;
font-size: 14px;
padding-bottom: 5px;
padding-top: 5px;
`;
 


const DialogProgramingDay =  ({
    opened,
    setDialogDayOpened,
    dayList=[],
    selectedDay,
    setSelectedDay
})=>{
    
    const [itemSelected,setItemSelected] = useState([]);

    const getdayColorStatus = (dateInfo,isSelected=false)=>{
      
        if ( isSelected ){
            return blue[500];
        }
        
        if ( dateInfo.is_complete === 'NONE' ){
            return grey[500];
        }
        if ( dateInfo.is_complete === 'NO' ){
            return '#BF5627';
        }
        if ( dateInfo.is_complete === 'SI' ){
            return '#1B7A4A';
        }
        if ( dateInfo.is_complete === 'PARCIAL' ){
            return yellow["500"];
        }
        
    }   
    useEffect(()=>{

        setItemSelected(selectedDay);

    },[selectedDay]);

    const ConfirmSelection = ()=>{
        setSelectedDay(itemSelected);
        setDialogDayOpened(false);
    };
    const onSelectItem = item=>{
       if ( item.fecha === itemSelected.fecha ){
        setItemSelected({});

       }else{
        setItemSelected(item);
       }
    }



    return (
        <Dialog
        maxWidth="sm"
        open={opened}
        >
            <DialogTitle>
                Dia de entrega
            </DialogTitle>
            <DialogContent>

                <Grid container spacing={1} >
                <Grid item container xs={12} sm={12} md={12}  >
                    <Grid item xs={3} sm={3} md={3} display={"flex"} alignContent={"center"} justifyContent={"center"} alignItems={"center"} >
                        <RadioButtonCheckedIcon style={{color:grey[500]}} /> <Typography variant="p" >N/A </Typography>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} display={"flex"} alignContent={"center"} justifyContent={"center"} alignItems={"center"} >
                        <RadioButtonCheckedIcon style={{color:'#BF5627'}} /> <Typography variant="p" >Pendiente  </Typography>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} display={"flex"} alignContent={"center"} justifyContent={"center"} alignItems={"center"} >
                        <RadioButtonCheckedIcon style={{color:yellow["500"]}} /> <Typography variant="p" >No finalizada  </Typography>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} display={"flex"} alignContent={"center"} justifyContent={"center"} alignItems={"center"} >
                        <RadioButtonCheckedIcon style={{color:'#1B7A4A'}} /> <Typography variant="p" >Finalizada  </Typography>
                    </Grid>
                    
                </Grid>
                    {
                        dayList.map( dateInfo=>
                        <Grid key={dateInfo.dia} item xs={2} sm={2} md={2}  >
                           
                            <DayContainerDefault  
                            style={{background:getdayColorStatus(dateInfo,dateInfo.fecha=== itemSelected?.fecha  )}}
                            onClick={e=>onSelectItem(dateInfo)}
                            
                            >
                            {`${ dateInfo.dia <10?'0'+dateInfo.dia:dateInfo.dia }`}
                            </DayContainerDefault>
                            
                        </Grid>
                        )
                    }
                    
                    
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button onClick={e=>setDialogDayOpened(false)} variant="contained" color="secondary" size="small" >Cerrar</Button>
                <Button onClick={ConfirmSelection} variant="contained" color="warning" size="small" >Guardar</Button>
            </DialogActions>
        </Dialog>
    )

}

let staticHeader = [
    {
        key:"proveedor",
        renderBody:"Proveedor",
        SubheaderRender:()=>null,
        subheaders:[]
    },
    {
        key:"fecha_entrega",
        renderBody:"fecha_entrega",
        SubheaderRender:()=>null,
        subheaders:[]
    },
    {
        key:"datos_carga",
        renderBody:"Datos de carga",
        SubheaderRender:({items})=> <table  style={{width:'100%'}}   >
            <thead>
                <tr>
                    {items?.map( sub_head_item=> <th style={{width:'calc(100%/3)'}}  key={sub_head_item.key} >{sub_head_item.renderBody}</th> )}
                
                
                </tr>
            </thead>
    </table>,
        subheaders:[
            {
                key:"producto",
                renderBody:"Producto",
            },
            {
                key:"unidad_medida",
                renderBody:"Unidades",
            },
            {
                key:"cantidad",
                renderBody:"Total KG",
            }
        ]
        
    },
   
    
    
   
];







const defaultDate = dayjs();

export const ProgramacionRegidas = (props)=>{

    const [dataSet,setDataSet] = useState([]);
    const [dataSetGlobal,setDataSetGlobal] = useState([]);
    const [subheaderData,setSubheaderData] = useState([]);
    const [headersTable,setHeadersTable] = useState([]);
    const [daysPrograming,setDaysProgramming] = useState([]);
    const [selectedDate,setSelectedDate] = useState(null);
    const [selectedDay,setSelectedDay] = useState({});
    const [dialogDayOpened,setDialogDayOpened] = useState(false);
    const [formRegSolicitud,setFormRegSolicitud] = useState({});

    const {dispatch,store} = useContext( AppContext );
    const isSelectedDay = selectedDay && Object.keys( selectedDay ).length > 0  ;


    React.useEffect(()=>{

        loadData();

    },[]);

    React.useEffect(()=>{

        loadData();

    },[selectedDate]);

    const calcDataSetFilter = (data = null)=>{
        if (selectedDay && Object.keys(selectedDay).length > 0){
            const resultDay =   data || dataSetGlobal.filter( item=>item.fecha_entrega === selectedDay.fecha );
           setDataSet(resultDay);
        }else{
            console.log("non set day");
            setDataSet(data);
        }
    }

    React.useEffect(()=>{
        
        if (selectedDay && Object.keys(selectedDay).length > 0){
            calcDataSetFilter();
      
         const subHeadResult = subheaderData.filter( item=>item.fecha_entrega === selectedDay.fecha );
         const indexItem = headersTable.findIndex( item=>item.key === 'distribucion_de_carga' );
         let copyHeader = [...headersTable];
      
         if ( indexItem !== -1 &&   subHeadResult.length > 0  ){
            copyHeader[indexItem] = getSubHeaderRender(subHeadResult);
            setHeadersTable(copyHeader);
         }else if(indexItem === -1 ){
            copyHeader.push( getSubHeaderRender(subHeadResult));
            setHeadersTable(copyHeader);
         }else{
            setHeadersTable(copyHeader.filter((_,index)=>index !== indexItem));
         }
        
        
        }else{
            setDataSet([...dataSetGlobal]);
        }
    },[selectedDay]);


    const getSubHeaderRender = (subHeaderSolicitudes)=>{

        return {
            key:"distribucion_de_carga",
            renderBody:"Distribucion de carga",
            SubheaderRender:({items})=> <table  style={{width:'100%'}}   >
        <thead>
            <tr>
                {items?.map( sub_head_item=> <th style={{width:'calc(100%/'+items.length+')'}}  key={sub_head_item.key} >{sub_head_item.renderBody}</th> )}
            
            
            </tr>
        </thead>
</table>,
            subheaders:subHeaderSolicitudes,
            
            
        }
    }

    const loadData = ()=>{
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
          });
        AxiosInstance.post("logistico/listar-recogidas-en-finca",{
            date_start:( defaultDate ||selectedDate).startOf("month").format("YYYY-MM-DD"),
            date_end:( defaultDate ||selectedDate).endOf("month").format("YYYY-MM-DD"),
            
        }).then(({data})=>{
            
            const arrayOfProgramingDate = [];
            const numerOfDaysInMonth = defaultDate.daysInMonth();
            Array.from({length:numerOfDaysInMonth}).forEach( (item,index)=>{
                
                const dateIndex = ( selectedDate || defaultDate ).date(index+1).format("YYYY-MM-DD");
                
                const found = data.value.fechas.find( date_program=>date_program.fecha === dateIndex );
                if ( found ){
                    arrayOfProgramingDate.push({
                        fecha:dateIndex,
                        dia:index+1,
                        is_complete:found.is_complete
                        
                    });
                }else{
                    arrayOfProgramingDate.push({
                        fecha:dateIndex,
                        dia:index+1,
                        is_complete:"NONE"
                        
                    });
                }
               
             
            });
            
            setDaysProgramming(arrayOfProgramingDate);
            calcDataSetFilter([...data.value.rows]);
            //setDataSet([...data.value.rows]);
            setDataSetGlobal([...data.value.rows]);
            const subHeaderSolicitudes = data.value.solicitudes.map( item=>({
                key:item.cod,
                fecha_entrega:dayjs(item.fecha_entrega_destino).format(DateFormatString),
                renderBody:`${item.cod} | ${dayjs(item.fecha).format('MM-DD')}->${dayjs(item.fecha_entrega_destino).format("MM-DD")} | ${item.tipo_vehiculo}`,
            }));
            console.log({subHeaderSolicitudes});
            const newHeader = [...staticHeader];

            newHeader.push(getSubHeaderRender(subHeaderSolicitudes));
            console.log({newHeader});
            setHeadersTable([...newHeader]);
            setSubheaderData(subHeaderSolicitudes);
            

        }).catch(result=>{


        }).finally(()=>{
            dispatch({
                type:ActionTypes.setLoadingPage,
                data:false
              });
        });
    }

    const onSaveItem = (parent_index,child_index,sol_index,data)=>{
        console.log({data});
      
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
          });
        const solicitudTransporte  = subheaderData[parent_index].key;
        if (  data.cantidad_ordenada > data.cantidad_comprada  ){
            dispatch({
                type: ActionTypes.setModalInfo,
                data: {
                  title: "Advertencia",
                  message: "La cantidad digitada es mayor a la cantidad comprada",
                  type: DialogType.peligro,
                  isVisible: true
                }
              });
              return;
        } 
        AxiosInstance.post("logistico/save-value-solicitudes",{
            cod_solicitud_transporte:data.cod_solicitud_transporte,
            cod_detalle_orden_compra:data.cod_detalle_orden_compra,
            cantidad_ordenada:data.cantidad_ordenada,
            cod_co_destino:data.cod_co_destino,
            cod_bodega_destino:data.cod_bodega_destino
        }).then(result=>{

        }).catch(err=>{
 dispatch({
                type: ActionTypes.setModalInfo,
                data: {
                  title: "Error",
                  message: "Cantidad no guardada, intente nuevamente",
                  type: DialogType.peligro,
                  isVisible: true
                }
              });
        }).finally(  ()=>{
            dispatch({
                type:ActionTypes.setLoadingPage,
                data:false
              });
        });
    }

    const onChangeItemData =(parent_index,child_index,sol_index,data,value)=>{
        console.log({parent_index,child_index,data,dataSet});
        const newDataSet = [...dataSet];
        
        newDataSet[parent_index].data[child_index].solicitud_data[sol_index].cantidad_ordenada = Number(value) || 0;
        setDataSet(newDataSet);
        
    }
    const getItemRowValue = (key,item,parent_index)=>{
        if ( key === 'proveedor' ){
            return item.proveedor.razon_social;
        }  
        if ( key === 'fecha_entrega' ){
            return item.fecha_entrega;
        }  
        if ( key === 'datos_carga' ){

            return  <table  style={{width:'100%',minWidth:'300px'}}   >
            <thead>
                {
                    item.data.map( ele=><>
                    <tr  key={ele.detalle_oc_cod+ele.nombre_producto} >
                       <th>
                        <table style={{width:'100%'}}  >
                            <tbody>
                            <th style={{width:'CALC(100%/3)',textAlign:"center",border:"1px solid gray",height:'60px',minHeight:'60px'}} >{ele.nombre_producto}</th>
                            <th style={{width:'CALC(100%/3)',textAlign:"center",border:"1px solid gray",height:'60px',minHeight:'60px'}} >{ele.cantidad_comprada+" "+ele.und_comprada}</th>
                            <th style={{width:'CALC(100%/3)',textAlign:"center",border:"1px solid gray",height:'60px',minHeight:'60px'}} >{ele.total_kg} KG</th>
                           
                            </tbody>
                        </table>
                       </th>
                    </tr>
                  
                   
                    </>
                    
                    )
                }
                
            </thead>
    </table>

        }
        if ( key === 'distribucion_de_carga' ){
            return  <table  style={{width:'100%',minWidth:'300px'}}   >
            <thead>
                {
                    item.data.map( (ele,child_index)=><>
                    <tr  key={ele.detalle_oc_cod+ele.nombre_producto} >
                       <th>
                                <table style={{ width: '100%' }}  >
                                    <tbody>
                                       
                                       <tr>
                                        {ele.solicitud_data?.map( (item_sol,sol_index)=> <th style={{ width: 'CALC(100%/' + ele.solicitud_data?.length +')',height:'60px',minHeight:'60px' }} >
                                            
                                            <div
                                            style={{
                                                display:"inline-block"
                                            }}
                                            >
                                            <Input 
                                               variant='outline'
                                               sx={{width:'50%'}}
                                               className={css`
                                               & input {
                                                text-align:center;
                                                
                                               }
                                               `}
                                                endAdornment={
                                                    <InputAdornment>
                                                        KG
                                                    </InputAdornment>
                                                }
                                                disabled={!isSelectedDay || ['CONFIRMADA'].includes(item_sol.status)}
                                                onChange={e=>onChangeItemData(parent_index,child_index,sol_index,item_sol,e.target.value)}
                                                id="input-with-icon-textfield"
                                                value={item_sol.cantidad_ordenada}
                                                
                                                
                                            /><Button type="button" onClick={e=>onSaveItem(parent_index,child_index,sol_index,item_sol)} size="small" variant="contained" ><Save sx={{fontSize:'20px',width:'22px'}} /></Button>
                                            </div>
                                            <HelperBodega>{ele.nombre_bodega}</HelperBodega>
                                        </th> )}
                                       
                                       </tr>
                                        
                                    </tbody>
                                </table>
                       </th>
                    </tr>
                  
                   
                    </>
                    
                    )
                }
                
            </thead>
    </table>

        }
        return  "vacio";
    }
    
    const onChangeMonth = (month)=>{
        setSelectedDay({});
        setSelectedDate(month);
    }

    const onAddNuevaSolicitud = ()=>{
        console.log(selectedDay,Object.keys( selectedDay ).length);
        if ( !isSelectedDay ){
         
            dispatch({
                type:ActionTypes.setModalInfo,
                data:{
                    title:"Fecha no valida",
                    message:"Debe seleccionar una fecha para poder agregar una solicitud",
                    type:DialogType.informativo,
                    isVisible:true
                }
            });
        return;   
        }
        setFormRegSolicitud({
            fecha_entrega:dayjs(selectedDay.fecha),
            opened:true
        });


    }

    const registrarSolicitud = (payload)=>{
        console.log({payload});
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
        });
     AxiosInstance.post("logistico/solicitudes-vehiculos",{
        fecha_recogida:dayjs(payload.fecha_recogida).format(DateFormatString),
        fecha_entrega:dayjs(payload.fecha_entrega).format(DateFormatString),
        cod_tipo_vehiculo:payload.tipo_vehiculo
     }).then(({data})=>{
        loadData();
        console.log({data});    
     }).catch(err=>{
        
            dispatch({
                type:ActionTypes.setModalInfo,
                data:{
                    title:"Error",
                    message:"Error al tratar de realizar el registro",
                    type:DialogType.peligro,
                    isVisible:true
                }
            });

     }).finally( ()=>{
        setFormRegSolicitud({});
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
        });
     } );
    }

    const onConfirmDay = ()=>{
        console.log({selectedDay});
       let errorArray = [];
       for (let itemData of dataSet){
      
        for (let pedido of itemData.data) {
            const totalKgAtransportar = pedido.solicitud_data.reduce((acum,item)=>{
             
               return  acum + item.cantidad_ordenada;
            },0); 
            if ( pedido.total_kg_ordenado < totalKgAtransportar ){
                errorArray.push(`<label style='font-weight:400' ><b>PROV:</b>${itemData.proveedor.razon_social} <b>ERROR:</b> El producto ${pedido.nombre_producto} sobrepasa la cantidad a transportar</label></br></br>`);
            }else{
                
            }
            if ( pedido.total_kg_ordenado > totalKgAtransportar ){
                errorArray.push(`<b>PROV:</b>${itemData.proveedor.razon_social} <b>ERROR:</b> El producto ${pedido.nombre_producto} no cumple con la cantidad a transportar</br></br>`);
            }
  
        }
           
       
       }

       if ( errorArray.length > 0  ){
        dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Advertencia",
                message:errorArray.join(" \n "),
                type:DialogType.peligro,
                isVisible:true
            }
            });
       }
       dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
    });
       AxiosInstance.post("logistico/confirmar-request-day",{
        fecha_entrega:selectedDay.fecha
       }).then(({data})=>{
        loadData();
        dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Proceso exitoso",
                message:"Solicitudes de transporte enviada",
                type:DialogType.exitoso,
                isVisible:true
            }
            });

       }).catch(err=>{

        dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error al tratar de confirmar el dia",
                type:DialogType.peligro,
                isVisible:true
            }
            });

       }).finally(()=>{
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
        });
       });

       console.log({errorArray});
       


    }

    return (
        <>
        {
            Object.keys(formRegSolicitud).length > 0 &&
                <RegistroSolicitud
                {...formRegSolicitud}
                onCloseModal={e=>setFormRegSolicitud({})}
                onsendForm={registrarSolicitud}
            />
        }
    


        <DialogProgramingDay
        opened={dialogDayOpened}
        setDialogDayOpened={setDialogDayOpened}
        dayList={daysPrograming}
        selectedDay={selectedDay}
        setSelectedDay={setSelectedDay}
        />
         <Grid container spacing={2} >
            <Grid item sm={12} xs={12} md={12} >
                <Typography variant="h6" >
                    Calendario de programacion - recogidas en finca
                </Typography>

              

            </Grid>
            <Grid item sm={2} xs={2} md={2} >
            <DatePicker
                    
                    views={["year","month"]}
                    openTo="month"
                    label='Fecha de entrega'
                    value={selectedDate}
                    onChange={onChangeMonth}
                    slotProps={{ textField: { size: "small" } }}
                />
            </Grid>
            <Grid item sm={2} xs={2} md={2} >
                <Button onClick={e=>setDialogDayOpened(true)} size="small" variant="contained" color="primary" >Dia a programar</Button>
            </Grid>
            <Grid item sm={12} xs={12} md={12} container >
                <Grid item sm={12}  xs={12} md={2} >
                    <Button onClick={onAddNuevaSolicitud} variant="contained" size="small" >Nueva solicitud</Button>
                </Grid>
                <Grid item sm={12} xs={12} md={2} >
               <Button onClick={onConfirmDay} disabled={!isSelectedDay} color="error" variant="contained" size="small" >Confirmar dia</Button>
            </Grid>
            </Grid>
           
            <Grid item sm={12} xs={12} md={12} >

                <TableContainer sx={{overflow:"scroll",minWidth:'90vw'}} >
                    <Table >
                        <TableHead>
                            <TableRow>
                                {
                                    headersTable.map( ({SubheaderRender,...item})=>
                                        <TableCell
                                        align="center"
                                        key={item.key}
                                        style={{borderStyle:"solid",borderWidth:1,borderColor:"gray"}}
                                        >
                                           
                                            {item.renderBody}
                                            {item.subheaders && 
                                             <SubheaderRender element={item}  items={item.subheaders} />
                                           }
                                            
                                        </TableCell>
                                        )
                                }
                               
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                dataSet.map((item,index_item)=><TableRow
                                key={item?.proveedor.cod+item?.fecha_entrega}
                                >
                                    {headersTable.map( (header_val)=><td
                                     style={{borderStyle:"solid",borderWidth:1,borderColor:"gray"}}
                                     key={header_val.key}
                                    >
                                        {getItemRowValue(header_val.key,item,index_item)}
                                    </td> )}
                                    </TableRow>
                                    )
                            }
                           
                        </TableBody>
                    </Table>
                </TableContainer>

            </Grid>
        </Grid>
        </>
    )

}